import { Component, OnInit, ViewChild } from '@angular/core';
import { ModalController, NavParams, IonSlides } from '@ionic/angular';
import { DomSanitizer } from '@angular/platform-browser';
let amp = window['amp'];
@Component({
  selector: 'image-modal-alert',
  templateUrl: './image-modal.component.html',
  styleUrls: ['./image-modal.component.scss']
})
export class ImageModalComponent implements OnInit {
  @ViewChild('mySlider') slides: IonSlides;
  srcImage: string;
  scrVideo: string;
  link: any;
  images: Array<any>;
  srcAzureVideo: string;
  srcDocument: string;
  myPlayer: any;
  currentPage: number = 0;
  initialPage: number = 0;
  isFom: boolean;

  slideOpts = {
    initialSlide: 0,
    speed: 400
  };

  constructor(private modalController: ModalController, private navParams: NavParams, private sanitizer: DomSanitizer) { }

  onIndexChange() {
    this.slides.getActiveIndex().then((index) => {
      this.currentPage = index;
      return index;
    })
  }
  slidePrev() {

    if (this.currentPage == 0) {
      this.slides.slideTo(this.images.length - 1, 10);
    } else {
      this.slides.slidePrev();
    }
  }
  slideNext() {
    if (this.currentPage == (this.images.length - 1)) {
      this.slides.slideTo(0, 10);
    } else {
      this.slides.slideNext();
    }
  }

  ngOnInit() {

    this.currentPage = this.navParams.get('currentPage');
    this.slideOpts.initialSlide = this.currentPage;
    this.initialPage = this.currentPage;
    this.srcImage = this.navParams.get('srcImage');
    this.scrVideo = this.navParams.get('scrVideo');
    this.srcAzureVideo = this.navParams.get('srcAzureVideo')
    this.srcDocument = this.navParams.get('srcDocument');
    this.images = this.navParams.get('images');
    var link = this.navParams.get('link');
    if (link) {
      this.link = this.sanitizer.bypassSecurityTrustResourceUrl(link)
    }

    if (document.getElementById('vidBig') && this.srcAzureVideo) {
      this.myPlayer = amp(document.getElementById('vidBig'), { /* Options */
        techOrder: ["azureHtml5JS", "flashSS", "html5FairPlayHLS", "silverlightSS", "html5"],
        autoplay: true,
        controls: false,
        height: "90%",

      });
      this.myPlayer.src({
        type: "video/mp4",
        src: this.srcAzureVideo
      });
    }
  }

  public cancel() {
    if (this.images && this.currentPage != this.initialPage) {
      this.modalController.dismiss(this.images[this.currentPage].article);
    }
    else {
      this.modalController.dismiss();
    }


  }

}
